import MessageBroker from '@bonprix/pattern-library/components/message-broker';
import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';
import Url from '@core/scripts/helper/url';
import Logger from '@core/scripts/components/logger';
import WishlistMessages from "../components/messages";

export default function addToWishlist(styleId, shopId, itemId, itemNumber, itemOptionId, eventId) {
    const url = Url.toAbsolute('list/wishlist/');

    const body = new FormData()
    body.append('articleNumber', itemNumber);
    body.append('digistyleId', styleId);
    body.append('shopId', shopId);
    body.append('itemId', itemId);
    if(itemOptionId !== undefined) {
        body.append('itemOptionId', itemOptionId);
    }

    return new Promise((resolve, reject) => {
        fetchWithCSRF(url, {
            method: "PUT",
            body
        }).then((response) => {
            if (response.ok) {
                response.text()
                    .then((text) => {
                        if (text){
                            reject(new Error(text));
                        } else {
                            MessageBroker.publish(WishlistMessages.WISHLIST.ITEM_ADDED, {
                                amountAdded: 1,
                                digistyleId: styleId,
                                itemId: itemId !== undefined ? parseInt(itemId) : null,
                                eventId: eventId
                            });
                            resolve();
                        }
                    });
            } else  {
                response.text()
                    .then((text) => {
                        reject(new Error(text));
                    });
            }
        }).catch((error) => {
            Logger.error('Could not add product to wishlist!', error);
            reject(error);
        });
    } );
}
